import React from "react";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { MdWork,MdSchool } from "react-icons/md";

function EducationCard() {
  return (
    <VerticalTimeline>
  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
    date="2016-2019"
    iconStyle={{ background: 'rgb(255, 25, 24)', color: '#fff' }}
    icon={<MdSchool />}
  >
    <h3 className="vertical-timeline-element-title">B.Sc in</h3>
    <h4 className="vertical-timeline-element-subtitle">Computer Science and Engineering</h4>
    <p>IUBAT - International University of Business Agriculture and Technology</p>
  </VerticalTimelineElement>

  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    contentStyle={{ background: 'rgb(50, 216, 84)', color: '#fff' }}
    contentArrowStyle={{ borderLeft: '7px solid  rgb(50, 216, 84)' }}
    date="2015"
    iconStyle={{ background: 'rgb(50, 216, 84)', color: '#fff' }}
    icon={<MdSchool />}
  >
    <h3 className="vertical-timeline-element-title">HSC</h3>
    <h4 className="vertical-timeline-element-subtitle">Science</h4>
    <p>Palashbari Govt. College</p>
  </VerticalTimelineElement>

  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
    date="2013"
    iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
    icon={<MdSchool />}
  >
    <h3 className="vertical-timeline-element-title">SSC</h3>
    <h4 className="vertical-timeline-element-subtitle">Science</h4>
    <p>Palashbari S.M Pilot High School</p>
  </VerticalTimelineElement>



  <VerticalTimelineElement
    iconStyle={{ background: 'rgb(255, 25, 24)', color: '#fff' }}
    icon={<MdSchool />}
  />
</VerticalTimeline>
  );
}

export default EducationCard;
